import React from 'react';

const MainContainer = ({ children }) => {
  return (
        <div className="erp-main">
        {children}
        </div>
  );
};

export default MainContainer;

